var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"error","loading":_vm.loading},on:{"click":() => _vm.removeContract()}},[_c('v-icon',{attrs:{"left":"","light":""}},[_vm._v(" mdi-delete-outline ")]),_vm._v(" Eliminar "+_vm._s(_vm.contract?.documentType.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }